var React = require('react/addons');
var cx = require('classnames');

var ReactForms = require('react-forms');
var PropTypes = ReactForms.PropTypes;
var Message = ReactForms.Message;
var Label = ReactForms.Label;
var Input = ReactForms.Input;
var FocusStore = ReactForms.FocusStore;
var Hint = require('react-forms/lib/Hint');


var Field = React.createClass({
  mixins: [FocusStore.FocusableMixin],

  propTypes: {
    label: React.PropTypes.string,
    hint: React.PropTypes.string,
    value: PropTypes.Value,
    input: React.PropTypes.oneOfType,
    noLabel: React.PropTypes.bool
  },

  render() {
    var {value, hint, label, noLabel, input, className, ...props} = this.props;
    var {node, validation, isDirty, externalValidation} = value;
    var isInvalid = isDirty && (validation.isFailure || externalValidation.isFailure);
    var required = node.props.get('required');

    var classNames = cx({
      'ofs-Form__Field': true,
      'ofs-Form__Field--invalid': isInvalid,
      'ofs-Form__Field--dirty': isDirty,
      'ofs-Form__Field--required': required
    });

    var id = this._rootNodeID;

    var label = label || node.props.get('label');

    if (required && typeof label !== 'undefined') {
      label += '*'
    }

    return (
      <div {...props} className={cx(classNames, className)} value={undefined}>
        {!noLabel &&
          <Label
            htmlFor={id}
            className="ofs-Form__Label"
            label={label}
            />}
        <Input
          ref="input"
          id={id}
          value={value}
          input={input}
          dirtyOnBlur={node.props.get('dirtyOnBlur', true)}
          dirtyOnChange={node.props.get('dirtyOnChange', true)}
          />
        {hint || node.props.get('hint') ? <Hint hint={hint || node.props.get('hint')} /> : null}
        {validation.isFailure && isDirty &&
          <Message>{validation.error}</Message>}
        {externalValidation.isFailure &&
          <Message>{externalValidation.error}</Message>}
      </div>
    );
  },

  focus() {
    this.refs.input.focus();
  }
});

module.exports = Field;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/components/better-field.jsx
 **/